import { ScreenConstants } from "../constants/screens";
import { SecondaryScreenLayoutVariant } from "../interfaces/secondaryScreens";

const getColumnPlayers = (column: SecondaryScreenLayoutVariant["columns"][0]) => {
  return {
    columns: column.playerColumns ?? ScreenConstants.DefaultPlayersColumns,
    rows: column.playerRows ?? ScreenConstants.DefaultPlayersRows,
  };
}

export const ScreenHelpers = {
  getColumnPlayers,
};